// The reason travels on ONE line. Backend writes it at the end of the account's trace line, and a
// line break inside it would split that line in two — anyone reading the observations line by
// line, a person or a query, would stop recognizing it. Any run of whitespace, breaks included,
// becomes one space; the ends are trimmed. Also the test for «is anything written at all».
export function normalizeReason(raw: string): string {
  return raw.replace(/\s+/g, ' ').trim();
}

// Backend rejects a longer reason with `400 invalid_data`. The field caps what is typed, and that
// is enough: normalizing can only shorten the text.
export const REASON_MAX_LENGTH = 500;
